import { render, staticRenderFns } from "./storyBoard.vue?vue&type=template&id=c2c564d4&scoped=true"
import script from "./storyBoard.vue?vue&type=script&lang=js"
export * from "./storyBoard.vue?vue&type=script&lang=js"
import style0 from "./storyBoard.vue?vue&type=style&index=0&id=c2c564d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c564d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c564d4')) {
      api.createRecord('c2c564d4', component.options)
    } else {
      api.reload('c2c564d4', component.options)
    }
    module.hot.accept("./storyBoard.vue?vue&type=template&id=c2c564d4&scoped=true", function () {
      api.rerender('c2c564d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSet/components/storyBoard.vue"
export default component.exports